import React from "react";
import Header from "./Header";
import Avatar from "./Avatar";
import Footer from "./Footer";

function App() {
  return (
    <div>
      <Header />
      <Avatar />
      <Footer />
    </div>
  );
}

export default App;
